"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useAPICallRepetitionFromError = require("../../hooks/error/useAPICallRepetitionFromError");
var _services = require("../../services");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ErrorBody = () => {
  const {
    errorMessage,
    retryAPICall,
    callIsInProgress
  } = (0, _useAPICallRepetitionFromError.useAPICallRepetitionFromError)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '80px'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Image, {
    sm: {
      src: _constants.ERROR_IMAGE
    }
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    weight: 3,
    size: 2,
    dataAttributes: {
      'data-test-id': 'error-title'
    }
  }, _services.Services.locale.localeString('ErrorPage.Heading')))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 9,
    colMd: 6
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    justify: "center",
    weight: 1,
    dataAttributes: {
      'data-test-id': 'error-subtitle'
    }
  }, errorMessage))))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '160px'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: "center",
    layout: {
      sm: [12],
      md: [6]
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    state: callIsInProgress ? 'disabled' : '',
    width: "full",
    text: _services.Services.locale.localeString('ErrorPage.Button'),
    onClick: retryAPICall
  }))));
};
var _default = ErrorBody;
exports.default = _default;